import img1 from './IMG-20250906-WA0018.jpg';
import img2 from './IMG-20250906-WA0019.jpg';
import img3 from './IMG_20250823_155411_842.jpg';
import img4 from './IMG-20250906-WA0020.jpg';
import img5 from './cama.jpg';
import img6 from './IMG-20250906-WA0018.jpg';
import img7 from './20250808_190240.jpg';
import img8 from './servicos2.jpg';
import img9 from './ambiente.jpg';
import img10 from './chaleextra.jpg';

const sliderImages = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
];

export default sliderImages;